import React from "react";

export default function Exam() {
  // Data normalized per class so the table can render with proper rowSpan
  const sessionTitle = "PROPOSED EXAMINATION SCHEDULE • SESSION 2024–2025";

  const rows = [
    // 25.07.2024 — Periodic I for IX, X, XII (CBSE)
    { cls: "IX CBSE", exam: "Periodic I", date: "25.07.2024", fm: "40", time: "1 Hr 30 Min" },
    { cls: "X CBSE", exam: "Periodic I", date: "25.07.2024", fm: "40", time: "1 Hr 30 Min" },
    { cls: "XII CBSE", exam: "Periodic I", date: "25.07.2024", fm: "40", time: "1 Hr 30 Min" },

    // 25.09.2024 — Periodic I for XI; Periodic II for IX, X, XII (CBSE)
    { cls: "XI CBSE", exam: "Periodic I", date: "25.09.2024", fm: "40", time: "1 Hr 30 Min" },
    { cls: "IX CBSE", exam: "Periodic II", date: "25.09.2024", fm: "40", time: "1 Hr 30 Min" },
    { cls: "X CBSE", exam: "Periodic II", date: "25.09.2024", fm: "40", time: "1 Hr 30 Min" },
    { cls: "XII CBSE", exam: "Periodic II", date: "25.09.2024", fm: "40", time: "1 Hr 30 Min" },

    // 25.11.2024 — Periodic III for IX; First Preboard for X; Periodic II for XI (CBSE)
    { cls: "IX CBSE", exam: "Periodic III", date: "25.11.2024", fm: "40", time: "1 Hr 30 Min" },
    { cls: "X CBSE", exam: "First Preboard", date: "25.11.2024", fm: "40", time: "1 Hr 30 Min" },
    { cls: "XI CBSE", exam: "Periodic II", date: "25.11.2024", fm: "40", time: "1 Hr 30 Min" },

    // 25.11.2024 — XII Preboard (CBSE)
    { cls: "XII CBSE", exam: "Preboard", date: "25.11.2024", fm: "70/80", time: "3 Hrs" },

    // 08.01.2025 — X Final Preboard (CBSE)
    { cls: "X CBSE", exam: "Final Preboard", date: "08.01.2025", fm: "80", time: "3 Hrs" },

    // 19.02.2025 — IX & XI Annual Exam (CBSE)
    { cls: "IX CBSE", exam: "Annual Exam", date: "19.02.2025", fm: "70/80", time: "3 Hrs" },
    { cls: "XI CBSE", exam: "Annual Exam", date: "19.02.2025", fm: "70/80", time: "3 Hrs" },

    // WBCHSE — XII Test Exam (date as per council guidelines)
    { cls: "XII WBCHSE", exam: "Test Exam (as per WBCHSE Guidelines)", date: "As directed by Council", fm: "70/80", time: "3 Hrs 15 Min" },
  ];

  // Group rows by class to render with rowSpan
  const grouped = rows.reduce((acc, r) => {
    if (!acc[r.cls]) acc[r.cls] = [];
    acc[r.cls].push(r);
    return acc;
  }, /** @type {Record<string, typeof rows>} */ ({}));

  const classesInOrder = Object.keys(grouped);

  return (
    <>
      <div className="container">
        <h2 id="h2">
          S.E. RAILWAY MIXED H S SCHOOL, ADRA (CAMPUS - I)
          <br />
          {sessionTitle}
        </h2>

        <table className="table">
          <thead>
            <tr>
              <th scope="col">Class</th>
              <th scope="col">Exam</th>
              <th scope="col">Proposed Date</th>
              <th scope="col">FM</th>
              <th scope="col">Time</th>
            </tr>
          </thead>

          <tbody>
            {classesInOrder.map((cls) => {
              const items = grouped[cls];
              return items.map((r, idx) => (
                <tr key={`${cls}-${r.exam}-${r.date}-${idx}`}>
                  {idx === 0 && (
                    <th scope="row" rowSpan={items.length}>
                      {cls}
                    </th>
                  )}
                  <td>{r.exam}</td>
                  <td>{r.date}</td>
                  <td>{r.fm}</td>
                  <td>{r.time}</td>
                </tr>
              ));
            })}
          </tbody>
        </table>

        <h3 id="h2" style={{ marginTop: "1rem" }}>
          Projects, Portfolio and Practical Exams are conducted by respective departments as per CBSE & WBCHSE guidelines.
        </h3>

        <div className="btndiv">
          {/* Point this href to your actual PDF once available, e.g. /ExamSchedule/Session_2024-25.pdf */}
          <a className="btn btn-primary" href="./public/Proposed Exam Schedule 2024-2025.pdf" target="_blank" rel="noopener noreferrer">
            Download Exam Schedule
          </a>
        </div>
      </div>
    </>
  );
}